import { useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";
import useStore from "@/pages/omni-builder/store";

export default function useWhatsAppConfig() {
  const queryClient = useQueryClient();
  const setIsWhatsappLoading = useStore((state) => state.setIsWhatsappLoading);
  return useQuery({
    queryKey: ["configurations", "whatsapp"],
    queryFn: async () => {
      const cachedData: any =
        queryClient.getQueryData(["configurations", "whatsapp"]) ?? null;

      if (!cachedData) {
        setIsWhatsappLoading(true);
      }
      const response = await axiosGet(
        "/configurations/getAppConfig?siteName=whatsapp",
      );
      let result: any = null;
      if (response.data) {
        result = {
          accessToken: response.data.accessToken,
          name: response.data.accountName,
          picture: response.data.picture,
          connections: response.data.connections,
          phoneNumbers: response.data.phoneNumbers,
          id: response.data.id,
        };
      }

      // result contains accessToken, profile, phoneNumbers & wabaIds
      setIsWhatsappLoading(false);
      return result;
    },
    staleTime: Infinity,
  });
}
